import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import {connect} from 'react-redux';
import {useParams} from 'react-router-dom';
import CustomRadioButton from '../common/CustomRadioButton';
import ActionButton from '../common/Action Buttons/ActionButton';
import ActionButton2 from '../common/Action Buttons/ActionButton2';
import ContractSignContainer from '../ContractSignContainer';
import ContractInfoSidePanel from '../contracts/ContractInfoSidePanel';
import CustomSidePanel from '../common/CustomSidePanel';
import ContractLineItem from '../contracts/ContractLineItem';
import {getCustomerContracts, getCompanyContracts, getAllContracts} from '../../redux/actions/contractsActions';
import ContractDeliveryDialog from '../contracts/ContractDeliveryDialog';


const PageWrapper = styled.div`
    display: flex;
    overflow: hidden;
    height: calc(100vh - var(--header-height));
    //height: 100px;
`;

const PageContent = styled.div`
    padding-left: 48px;
    padding-top: 84px;
    padding-bottom: 84px;
    flex: 1;
    overflow-y: scroll;
`;

const ContractWrapper = styled.div`
    display: grid;
    grid-row-gap: 50px;
   
`;

const ContractInfo = styled.div`
    display: grid;
    grid-template-columns: max-content max-content max-content;
    grid-template-rows: 1fr 1fr;
    grid-column-gap: 32px;
    grid-row-gap: 20px;    
`;

const ContractInfo1 = styled.div`
    display: flex;
    flex-direction: column;
    margin-bottom: 40px;
`;

const DialogAction = styled.div`
    width: 100%;
    height: fit-content;
    
    margin: 20px;
    display: flex;
    flex-direction: row;
    justify-content: start;
    
     > * {
      margin-right: 24px;
    }
`;

const DialogSubHead = styled.div`
    color: var(--color-black);
    margin-bottom: 44px;
`;

const DialogForm = styled.div`
    color: var(--color-black);
    margin-bottom: 44px;
`;

function ProfileContracts({contracts, getCustomerContracts, getCompanyContract, getAllContracts, auth}) {
    const params = useParams();
    const customerId = params.customerSlug || false;
    const companyId = params.companySlug || false;

    // on mounted
    // useEffect(() => {
    //     if (!contracts || !contracts.length) {
    //         // fetch contracts
    //         // TODO determine if the user is allowed to make this call. ie. only GK user can make this call.
    //         getCustomerContracts(companyId, customerId);
    //     }
    // }, [companyId, contracts, customerId, getCustomerContracts]);

    useEffect(() => getCustomerContracts(companyId, customerId), [companyId, customerId, getCustomerContracts]);

    // Filter contracts for the customer
    // contracts = contracts.filter(item => );

    const [drawerOpen, setDrawerOpen] = useState(false);
    const [signContract, setSignContract] = useState(false);
    const [selectedContract, setSelectedContract] = useState(null);
    const [openDialog, setOpenDialog] = useState(false);
    const [radioOption, setRadioOption] = useState(undefined);

    const openContractInfoPanel = contract => {
        setSelectedContract(contract);
        setDrawerOpen(true);
    };

    const handleOnDrawerClose = () => {
        setDrawerOpen(false);
        setSelectedContract(null);
    };

    const handleOnViewContractClick = () => {
        setDrawerOpen(false);
    };

    const handleSignContractClick = () => {
        //setDrawerOpen(false);
        setSignContract(true);
    };

    const handleReadyForDeliveryClick = () => {
        setDrawerOpen(false);
        setOpenDialog(true);
    };

    const handleDialogClose = () => {
        setOpenDialog(false);
    };

    const handleOnSubmit = () => {

    };

    const handleOnRadioChange = () => {

    };

    return (
        <PageWrapper>
            <PageContent>
                <ContractWrapper>
                    {
                        contracts.map(item => (
                            <ContractLineItem
                                key={item.id}
                                contractId={item.contractNumber}
                                status={item.status}
                                startDate={item.startDateOfContract}
                                endDate={item.endDateOFContract}
                                monthlyPayment={item.monthlyPayment}
                                totalCashPrice={item.totalCashPrice}
                                onMoreBtnClick={() => {
                                    openContractInfoPanel(item);
                                }}
                                onContractIdClick={() => {
                                    openContractInfoPanel(item);
                                }}
                            />
                        ))
                    }
                </ContractWrapper>

                <ContractInfoSidePanel
                    contract={selectedContract || {}}
                    showPanel={drawerOpen}
                    onPanelClose={handleOnDrawerClose}
                    onSignContractClick={handleSignContractClick}
                    onViewContractClick={handleOnViewContractClick}
                    onReadyForDeliveryClick={handleReadyForDeliveryClick}
                    role={auth && auth.role}
                />

                <ContractSignContainer
                    contracts={[selectedContract]}
                    onPanelClose={() => setSignContract(false)}
                    showPanel={signContract}
                />

                <ContractDeliveryDialog
                    id={selectedContract && selectedContract.contractNumber}
                    companyName={selectedContract && selectedContract.companyName}
                    onCloseClick={handleDialogClose}
                    onSubmitClick={handleOnSubmit}
                    showDialog={openDialog}
                    onDialogClose={handleDialogClose}
                />
            </PageContent>
        </PageWrapper>
    );
}

ProfileContracts.propTypes = {
    customer: PropTypes.object.isRequired,
    contracts: PropTypes.object.isRequired,
    getContractsForCompanyCall: PropTypes.func.isRequired,
    getContractsForCustomerCall: PropTypes.func.isRequired
};
ProfileContracts.defaultProps = {};

const mapStateToProps = state => {
    const {contracts} = state;
    return {
        auth: state.auth,
        contracts
    };
};

const mapDispatchToProps = {
    getAllContracts,
    getCustomerContracts,
    getCompanyContract: getCompanyContracts
};

export default connect(mapStateToProps, mapDispatchToProps)(ProfileContracts);
